/** Filter outlets to the user's assigned scope (empty scope = all outlets). */
export function filterOutletsByUserScope<T extends { _id?: string }>(
  outlets: T[],
  outletScope: string[] | null | undefined,
): T[] {
  const scope = Array.isArray(outletScope)
    ? outletScope.map(String).filter(Boolean)
    : [];
  if (!scope.length) return outlets;
  const allowed = new Set(scope);
  return outlets.filter((o) => o?._id && allowed.has(String(o._id)));
}

/** Keep the preferred outlet when still allowed, otherwise first scoped outlet. */
export function pickScopedOutlet<T extends { _id?: string }>(
  outlets: T[],
  preferred: T | string | null | undefined,
): T | null {
  if (!outlets.length) return null;
  const preferredId =
    preferred && typeof preferred === 'object'
      ? String(preferred._id || '')
      : String(preferred || '');
  if (preferredId) {
    const match = outlets.find((o) => String(o._id) === preferredId);
    if (match) return match;
  }
  return outlets[0];
}
